// extracted by mini-css-extract-plugin
export default {"selectTypeSection":"PricingSelectType_selectTypeSection__Grpt5","divider":"PricingSelectType_divider__XT6dH"};